import { useContext } from 'react';

import {
    PatientContext,
    type PatientContextType,
} from '../contexts/patient/PatientProvider';

export const usePatientContext = (): PatientContextType =>
    useContext(PatientContext);
